import type { options, reqOptions } from './types/request';

import { AxiosRequestHeaders } from 'axios';
import { getToken } from '../auth';

const API_URL =
  process.env.NEXT_PUBLIC_API_URL != undefined
    ? process.env.NEXT_PUBLIC_API_URL
    : '/api';

const HEADERS = {
  Accept: 'application/json',
};

export const setOptions = (options: reqOptions): options => {
  let altHeaders: AxiosRequestHeaders = {};

  if (options.data) {
    altHeaders['Content-Type'] = 'application/json';
  }

  let authToken = '';
  if (typeof window !== 'undefined' && getToken().length && getToken() !== 'guest-user') {
    authToken = getToken();
  } else if (options.sessionCookie?.length && options.sessionCookie !== 'guest-user') {
    authToken = options.sessionCookie;
  }

  if (options.protected && authToken.length && authToken !== 'undefined') {
    altHeaders = { Authorization: `Token ${authToken}` };
  }

  const cleanUrl = options.url.startsWith('/') ? options.url.substring(1) : options.url;
  const baseUrl = API_URL.endsWith('/') ? API_URL.slice(0, -1) : API_URL;

  return {
    headers: {
      ...HEADERS,
      ...altHeaders,
    },
    params: options.data ? { ...options.data } : undefined,
    url: `${baseUrl}/${cleanUrl}`,
  };
};
